const translationConfig =
  {
    'bg': 'Влезте като служител',
    'cn': '以员工身份登录',
    'de': 'Melden Sie sich als Mitarbeiter an',
    'fr': "Connectez-vous en tant qu'employé",
    'hu': 'Jelentkezzen be alkalmazottként',
    'it': 'Accedi come dipendente',
    'ko': '직원으로 로그인',
    'nl-NL': 'Meld u aan als medewerker',
    'ro': 'Conectați-vă ca angajat',
    'ru': 'Войти как сотрудник',
    'tr': 'Çalışan olarak oturum aç',
    'uk': 'Увійдіть як співробітник',
    'id': 'Masuk dengan ID Cargill',
    'pt-BR': 'Entre com o ID da Cargill',
    'pl': 'Zaloguj się za pomocą Cargill ID',
    'es': 'Iniciar sesión con Cargill ID',
    'en': 'Sign In as an Employee'
  };
export default translationConfig;



// WEBPACK FOOTER //
// ./src/helpers/translationConfig.js